import { gql } from "shared/lib/graphql"
import { LiveChannelsPartialQuery } from "shared/components/stored_fields/service_account_select_field/queries.js"

export const DIYLoadServiceTriggersAndFieldsQuery = gql`
  query($serviceModuleName: String!) {
    channel(module_name: $serviceModuleName) {
      ${LiveChannelsPartialQuery}
      public_triggers {
        module_name
        full_module_name
        normalized_module_name
        name
        description
        id
        weight

        trigger_fields {
          name
          label
          required
          shareable
          hideable
          field_ui_type
          normalized_field_type
          helper_text
        }

        ingredients {
          id
          name
          normalized_name
          label
          note
          slug
          value_type
          example
        }
      }
    }
  }
`

export const DIYLoadServiceActionsAndFieldsQuery = gql`
  query($serviceModuleName: String!) {
    channel(module_name: $serviceModuleName) {
      ${LiveChannelsPartialQuery}
      public_actions {
        module_name
        full_module_name
        normalized_module_name
        name
        description
        id
        weight
        incompatible_triggers

        action_fields {
          name
          normalized_module_name
          label
          required
          shareable
          hideable
          field_ui_type
          normalized_field_type
          helper_text
        }
      }
    }
  }
`

export const DIYLoadServiceQueriesAndFieldsQuery = gql`
  query($serviceModuleName: String!) {
    channel(module_name: $serviceModuleName) {
      ${LiveChannelsPartialQuery}
      public_queries {
        module_name
        full_module_name
        normalized_module_name
        name
        description
        id
        weight

        query_fields {
          name
          label
          required
          shareable
          hideable
          field_ui_type
          normalized_field_type
          helper_text
        }

        ingredients {
          id
          name
          normalized_name
          label
          note
          slug
          value_type
          example
        }
      }
    }
  }
`

export const FilterCodeGeneratorsQuery = gql`
  query ($triggerIds: [String]!, $queryIds: [String]!, $actionIds: [String]!) {
    filter_code_generators(
      trigger_ids: $triggerIds
      query_ids: $queryIds
      action_ids: $actionIds
    ) {
      id
      description
      helper_text
      templates {
        action
        variations {
          code
          validation
        }
      }
      title
      type
      variables {
        term
        type
        options {
          label
          value
        }
      }
    }
  }
`

export const AppletTriggerFieldValidationMutation = gql`
  mutation($trigger: DiyStepValidationInput, $applet_id: String) {
    appletStepFieldValidation(input: { trigger: $trigger, applet_id: $applet_id }) {
      errors {
        attribute
        message
      }
    }
  }
`

export const AppletQueryFieldValidationMutation = gql`
  mutation($trigger: DiyStepValidationInput, $query: DiyStepValidationInput, $applet_id: String) {
    appletStepFieldValidation(input: { trigger: $trigger, query: $query, applet_id: $applet_id }) {
      errors {
        attribute
        message

     }
    }
  }
`

export const AppletActionFieldValidationMutation = gql`
  mutation(
    $trigger: DiyStepValidationInput
    $queries: [DiyStepValidationInput]
    $action: DiyStepValidationInput
    $applet_id: String
  ) {
    appletStepFieldValidation(
      input: { trigger: $trigger, queries: $queries, action: $action, applet_id: $applet_id }) {
      errors {
        attribute
        message
      }
    }
  }
`

export const StatementPreviewMutation = gql`
  mutation($stored_fields: JSON) {
    statementPreview(input: { stored_fields: $stored_fields }) {
      normalized_applet {
        name
        brand_color
        service_slug
      }
      push_enabled
      errors {
        attribute
        message
      }
    }
  }
`

export const AutoActivateMutation = gql`
  mutation($serviceModuleName: String!) {
    liveChannelCreate(input: { channel_module_name: $serviceModuleName }) {
      live_channel {
        offline
      }
      errors {
        attribute
        message
      }
    }
  }
`

export const DIYCreateAppletMutation = gql`
  mutation(
    $name: String!
    $description: String
    $channel_id: ID!
    $push_enabled: Boolean
    $filter_code: String
    $trigger: DiyTandaInput!
    $queries: [DiyTandaInput]
    $actions: [DiyTandaInput]!
    $actions_delay: Int
  ) {
    diyAppletCreate(
      input: {
        name: $name
        description: $description
        channel_id: $channel_id
        filter_code: $filter_code
        push_enabled: $push_enabled
        trigger: $trigger
        queries: $queries
        actions: $actions
        actions_delay: $actions_delay
      }
    ) {
      errors {
        attribute
        message
      }
      normalized_applet {
        id
      }
    }
  }
`

export const DIYAppletEditMutation = gql`
  mutation(
    $applet_id: String!
    $name: String!
    $description: String
    $channel_id: ID!
    $push_enabled: Boolean
    $filter_code: String
    $trigger: DiyTandaInput!
    $queries: [DiyTandaInput]
    $actions: [DiyTandaInput]!
    $actions_delay: Int
  ) {
    diyAppletEdit(
      input: {
        applet_id: $applet_id
        name: $name
        description: $description
        channel_id: $channel_id
        filter_code: $filter_code
        push_enabled: $push_enabled
        trigger: $trigger
        queries: $queries
        actions: $actions
        actions_delay: $actions_delay
      }
    ) {
      errors {
        attribute
        message
      }
      normalized_applet {
        id
      }
    }
  }
`

export const AppletFilterCodeValidationMutation = gql`
  mutation(
    $filter_code: String!
    $trigger: DiyStepValidationInput
    $queries: [DiyStepValidationInput]
    $actions: [DiyStepValidationInput]
  ) {
    appletFilterCodeValidation(
      input: {
        filter_code: $filter_code
        trigger: $trigger
        queries: $queries
        actions: $actions
      }
    ) {
      errors {
        attribute
        message
      }
    }
  }
`
export const NormalizedAppletEnableMutation = gql`
  mutation(
    $applet_id: String
    $name: String
    $push_enabled: Boolean
    $stored_fields: JSON
    $metadata: JSON
    $filter_code: String
    $actions_delay: Int
  ) {
    normalizedAppletEnable(
      input: {
        applet_id: $applet_id
        name: $name
        push_enabled: $push_enabled
        stored_fields: $stored_fields
        metadata: $metadata
        filter_code: $filter_code
        actions_delay: $actions_delay
      }
    ) {
      errors {
        attribute
        message
      }
      user_token
      normalized_applet {
        id
      }
    }
  }
`

export const LoadPrivateServicesQuery = gql`
  query {
    me {
      private_channels {
        id
        description_html
        module_name
        normalized_module_name
        name
        lrg_variant_image_url
        lrg_monochrome_image_url
        brand_color
        incompatible_channels
        allow_multiple_live_channels
        public_triggers: triggers {
          module_name
          full_module_name
          name
          description
          id
          weight
        }
        public_actions: actions {
          module_name
          full_module_name
          name
          description
          id
          weight
          incompatible_triggers
        }
        public_queries: queries {
          module_name
          full_module_name
          name
          description
          id
          weight
        }
      }
    }
  }
`
